// extracted by mini-css-extract-plugin
module.exports = {"newContent":"styles_newContent__y05KS","form":"styles_form__23zq9"};